<template>
    <div id="news">
        <toolbar-component :title="$t('news_page.actualities')"/>

        <div class="mx-auto" v-if="!loading_articles">
            <v-row class="ma-0 pa-4">
                <v-col v-for="article in articles" :key="article.title" cols="12" md="6" lg="4">
                    <v-card height="100%" max-width="600px" class="mx-auto article-wrapper">
                        <v-card-title class="pa-0">
                            <img :src="article.image" :alt="article.image_alt" width="100%">
                        </v-card-title>

                        <v-card-text class="pt-2">
                            <span class="font-24 secondary--text">{{ article.title }}</span>
                        </v-card-text>

                        <v-card-actions class="justify-space-between">
                            <span>{{ article.date }}</span>
                            <a :href="article.link" target="_blank">
                                <v-icon color="primary" small class="mb-1">mdi-open-in-new</v-icon>
                                {{ $t('news_page.read_more') }}
                            </a>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-row class="ma-0 pa-4" v-if="loading_articles">
            <v-col v-for="i in 6" :key="i" cols="12" md="6" lg="4">
                <v-skeleton-loader loading type="image, list-item-three-line, list-item"/>
            </v-col>
        </v-row>

        <div class="text-center mb-6">
            <a class="secondary--text font-weight-bold text-decoration-none"
               href="https://oleo100.com/actualites/articles" target="_blank"
            >
                {{ $t('news_page.find_all_article_on_site') }}
                <v-icon color="secondary">mdi-arrow-right-thin</v-icon>
            </a>
        </div>
    </div>
</template>

<script>

import ToolbarComponent from "@/components/Global/ToolbarComponent";
import GlobalRepository from "@/repositories/GlobalRepository";

export default {
    name: 'news',
    components: {ToolbarComponent},
    data() {
        return {
            articles: [],
            loading_articles: false
        }
    },
    created() {
        this.getScrapedArticles();
    },
    methods: {
        getScrapedArticles() {
            this.loading_articles = true;
            GlobalRepository.getScrapedArticles().then((success) => {
                this.articles = success.data.data;
            }).catch((error) => {
                this.manageError(error)
            }).finally(() => {
                this.loading_articles = false;
            });
        }
    }
}
</script>

<style>
.article-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>